export default __webpack_public_path__ + "static/media/sales-funnel.9bfc228a.jpg";